import axios from "axios";
import {toast} from "vue3-toastify";

//const baseUrl = "https://localhost:7298/";
const baseUrl = "https://apivaliamr.najah.ir/";
const apiUrl = "api/";
const url = baseUrl + apiUrl;

const baseService = axios.create({
    baseURL: url,
    withCredentials: false,
    headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json'
    },
});

baseService.interceptors.request.use(config => {
    const accessToken = getAuthToken();
    if (accessToken && accessToken.trim()) {
        config.headers['Authorization'] = 'bearer ' + accessToken.trim();
    }

    return config;
});


baseService.interceptors.response.use(
    // @ts-ignore
    function (response) {
        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        };
    },
    function (error) {
        if (!error.response) {
            console.error("Network or server connection error:", error);
            const netErrorMsg = "خطا در برقراری ارتباط با سرور. لطفاً اتصال اینترنت یا سرور را بررسی کنید.";
            if (!error.config?.skipToast) {
                toast.error(netErrorMsg, {
                    autoClose: 6000,
                    rtl: true,
                    position: toast.POSITION.TOP_LEFT,
                });
            }
            return {
                data: netErrorMsg,
                status: 0,
                statusText: error.message || "Network Error"
            };
        }

        console.error("API Error Details:", {
            url: error.config?.url,
            method: error.config?.method,
            params: error.config?.params,
            status: error.response.status,
            data: error.response.data
        });

        let outErrors = "خطاهای زیر را بررسی کنید:\n";
        if (error.response.status == 400) {
            if (error.config?.skipToast) {
                return {
                    data: null,
                    status: error.response.status,
                    statusText: error.message
                };
            }

            if (typeof error.response.data === "string") {
                outErrors += error.response.data + "\n";
            } else if (error.response.data && typeof error.response.data === "object") {
                if (error.response.data.errors == undefined) {
                    for (let eKey in error.response.data) {
                        if (eKey === undefined)
                            outErrors = error.response.data;
                        else
                            outErrors += error.response.data[eKey] + "\n";
                    }
                }
                for (let eKey in error.response.data.errors) {
                    for (let i = 0; i < error.response.data.errors[eKey].length; i++) {
                        outErrors += error.response.data.errors[eKey][i] + "\n";
                    }
                }
            }
            toast.error(outErrors, {
                autoClose: 6000,
                rtl: true,
                position: toast.POSITION.TOP_LEFT,
            });
        } else if (error.response.status == 500 && !error.config?.skipToast) {
            let errorMsg = "خطای داخلی سرور (500) رخ داده است.";
            if (typeof error.response.data === "string" && error.response.data.trim()) {
                errorMsg += "\n" + error.response.data;
            } else if (error.response.data?.message) {
                errorMsg += "\n" + error.response.data.message;
            }
            toast.error(errorMsg, {
                autoClose: 6000,
                rtl: true,
                position: toast.POSITION.TOP_LEFT,
            });
        }

        if (error.response.status == 401) {
            console.warn("API 401 Unauthorized encountered. Clearing expired auth credentials...");
            deleteCookie("accessToken");
            deleteCookie("refreshToken");
            try {
                localStorage.removeItem("useStore");
                sessionStorage.clear();
            } catch (e) {}

            if (typeof window !== "undefined" && !window.location.pathname.toLowerCase().includes("/signin")) {
                const redirectPath = window.location.pathname + window.location.search;
                window.location.href = "/signin?redirect=" + encodeURIComponent(redirectPath);
            }
        }

        return {
            data: error.response.data || outErrors,
            status: error.response.status,
            statusText: error.message
        };
    }
);

export function getAuthToken(): string {
    // 1. Try cookie
    const fromCookie = getCookie("accessToken");
    if (fromCookie && fromCookie.trim()) {
        return fromCookie.trim();
    }

    // 2. Try localStorage (Pinia persisted store)
    try {
        const storedStr = localStorage.getItem("useStore");
        if (storedStr) {
            const parsed = JSON.parse(storedStr);
            if (parsed?.accessToken && typeof parsed.accessToken === "string" && parsed.accessToken.trim()) {
                return parsed.accessToken.trim();
            }
        }
    } catch (e) {}

    // 3. Try sessionStorage fallback
    try {
        const sessionStr = sessionStorage.getItem("useStore");
        if (sessionStr) {
            const parsed = JSON.parse(sessionStr);
            if (parsed?.accessToken && typeof parsed.accessToken === "string" && parsed.accessToken.trim()) {
                return parsed.accessToken.trim();
            }
        }
    } catch (e) {}

    return "";
}

export function getCookie(c_name: string): string {
    if (typeof document === "undefined" || !document.cookie) {
        return "";
    }
    const nameEq = c_name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(nameEq) === 0) {
            const val = c.substring(nameEq.length, c.length);
            try {
                return decodeURIComponent(val);
            } catch (e) {
                return unescape(val);
            }
        }
    }
    return "";
}

export function deleteCookie(c_name: string) {
    if (typeof document !== "undefined") {
        document.cookie = c_name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Lax;";
    }
}

export default baseService;
